import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { Message } from './types';
import { Time, TimeProps } from 'react-native-gifted-chat';
import { TYPOGRAPHY } from '@/styles';

type Props = TimeProps<Message> & {
  textColor?: string;
};

export const ChatTime: React.FC<Props> = ({ textColor, ...rest }) => {
  const [styles, theme] = useStyles();

  const timeTextStyle = [
    TYPOGRAPHY.tiny,
    styles.timeText,
    { color: textColor || theme.colors.primary },
  ];
  return (
    <Time
      {...rest}
      containerStyle={{
        left: styles.container,
        right: styles.container,
      }}
      timeTextStyle={{
        left: timeTextStyle,
        right: timeTextStyle,
      }}
    />
  );
};

const useStyles = createStyles((theme) => ({
  container: {
    // Declare individually to override original styles
    marginBottom: 0,
    marginLeft: 0,
    marginRight: 0,
    marginTop: 0,
    paddingTop: 2,
  },
  timeText: {
    color: theme.colors.primary,
    opacity: 0.4,
  },
}));
